import React, { useState } from 'react';

import { Dialog } from 'components/designSystem/Dialog';
import { TextFormField } from 'components/designSystem/inputs/TextField';
import { TertiaryButton } from 'components/designSystem/TertiaryButton';
import { PrimaryButton } from 'components/designSystem/PrimaryButton';
import { makeStyles } from '@material-ui/core';
// import { CheckCircle } from '@material-ui/icons';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';

import { Form } from 'react-final-form';
import { required } from 'lib/formValidators';
import { useDataProvider, useTranslate, useNotify } from 'ra-core';
import { handleCreateProject } from './CreateProjectDialog.model';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  bottomContainer: {
    display: 'flex',
    // alignItems: 'center',
    marginTop: theme.spacing(3),
    justifyContent: 'end',
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    alignItems: 'center',

    '& button': {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      marginLeft: 16,
      fontSize: 14,
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '16px',
  },
}));

export const CreateProjectDialog = ({ clientId, clientName, isOpen, close, refresh }) => {
  const t = useTranslate();
  const notify = useNotify();
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const [loading, setLoading] = useState(false);

  return (
    <Dialog isOpen={isOpen} close={close} title={t('resources.projects.createModal.title', { clientName })}>
      <Form
        onSubmit={handleCreateProject({ dataProvider, clientId, close, setLoading, refresh, notify })}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className={classes.form}>
            <div className={classes.content}>
              <TextFormField
                name="name"
                validate={required(t)}
                dense
                size="full"
                required
                label={t('resources.projects.name')}
                iconError={<WarningRoundedIcon />}
                iconPosition="right"
                placeholder={t('resources.projects.fields.namePlaceholder')}
              />
            </div>
            <div className={classes.content}>
              <TextFormField
                name="description"
                validate={required(t)}
                dense
                required
                size="full"
                iconError={<WarningRoundedIcon />}
                iconPosition="right"
                label={t('resources.projects.description')}
                placeholder={t('resources.projects.fields.descriptionPlaceholder')}
              />
            </div>

            <div className={classes.bottomContainer}>
              <TertiaryButton disabled={loading} label={t('resources.projects.buttons.cancel')} onClick={close} />
              <PrimaryButton
                disabled={loading}
                type="submit"
                label={t('actionButtons.create')}
                onClick={handleSubmit}
                // icon={<CheckCircle />}
              />
            </div>
          </form>
        )}
      />
    </Dialog>
  );
};
